import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    CircularProgress,
} from "@mui/material";

export default function FilterDialog({
    open,
    title = "Filters",
    children,
    onClose,
    onSubmit
}) {
    if (!open) return null;

    return (

        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            {/* Header */}
            <div className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center">
                <h2 className="text-16 font-semibold">{title}</h2>
                <button
                    className="text-gray-500 hover:text-gray-700"
                    onClick={onClose}
                >
                    ✕
                </button>
            </div>

            {/* Body */}
            <DialogContent className="p-6 bg-gray-50 h-[100vh] overflow-y-auto">
                {children}
            </DialogContent>

            {/* Footer */}
            <div className="flex justify-end gap-2 px-4 py-3 border-t">
                <button
                    onClick={onClose}
                    className="mx-2 px-4 py-2 bg-gray-300 rounded-md text-12"
                >
                    Close
                </button>
                <button
                    onClick={onSubmit}
                    className="bg-gradient-to-r from-[#0E4C84] to-[#00A7C1] hover:from-[#135EA0] hover:to-[#00B8D4] text-white px-5 py-2 rounded-lg text-12 font-medium shadow-md shadow-cyan-500/30 hover:shadow-cyan-400/40 transition-all duration-300"
                >
                    Apply Filters
                </button>
            </div>
        </Dialog>

    );


}
